/**
 * @repo/reporting – Configuration Defaults
 *
 * Merkezi sabit değerler. Değiştirmek yerine ReportingProvider props ile override edin (OCP).
 */

import { reportingCulture } from '../localization/reporting-messages.js';

/** Reporting server (apps/reporting-server .NET sidecar) varsayılan adresi */
export const DEFAULT_REPORTING_HOST = 'http://localhost:5150';

/** DX WebDocumentViewer'ın server-side invoke action route'u */
export const DEFAULT_VIEWER_INVOKE_ACTION = 'DXXRDV';

/** DX ReportDesigner'ın server-side invoke action route'u */
export const DEFAULT_DESIGNER_INVOKE_ACTION = 'DXXRD/GetDesignerModel';

/** DX QueryBuilder invoke action route'u */
export const DEFAULT_QUERYBUILDER_INVOKE_ACTION = 'DXXQB';

/** Varsayılan viewer yüksekliği */
export const DEFAULT_VIEWER_HEIGHT = '800px';

/** Varsayılan designer yüksekliği */
export const DEFAULT_DESIGNER_HEIGHT = '900px';

/**
 * ReportViewer için varsayılan requestOptions oluşturucu.
 * @param {string} host - Reporting server base URL
 * @param {string} [authToken] - JWT token (varsa Authorization header'a eklenir)
 * @param {string} [tenantId] - Doğrulanacak tenant bağlamı
 */
export function buildViewerRequestOptions(host, authToken, tenantId, locale) {
    const rawHost = host ?? DEFAULT_REPORTING_HOST;
    const baseHost = rawHost.endsWith('/') ? rawHost : `${rawHost}/`;
    const culture = reportingCulture(locale);

    return {
        host: baseHost,
        invokeAction: DEFAULT_VIEWER_INVOKE_ACTION,
        getViewerModelAction: DEFAULT_VIEWER_INVOKE_ACTION,
        getLocalizationAction: DEFAULT_VIEWER_INVOKE_ACTION,
        ...(authToken || tenantId || culture
            ? {
                headers: {
                    ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
                    ...(tenantId ? { 'X-Reporting-Tenant-Id': tenantId } : {}),
                    ...(culture ? { 'Accept-Language': culture } : {}),
                },
            }
            : {}),
    };
}

/**
 * ReportDesigner for default requestOptions builder.
 * @param {string} host - Reporting server base URL
 * @param {string} [authToken] - JWT token
 * @param {string} [tenantId] - Doğrulanacak tenant bağlamı
 */
export function buildDesignerRequestOptions(host, authToken, tenantId, locale) {
    const rawHost = host ?? DEFAULT_REPORTING_HOST;
    const baseHost = rawHost.endsWith('/') ? rawHost : `${rawHost}/`;
    const culture = reportingCulture(locale);

    return {
        host: baseHost,
        getDesignerModelAction: DEFAULT_DESIGNER_INVOKE_ACTION,
        developmentMode: true,
        ...(authToken || tenantId || culture
            ? {
                headers: {
                    ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
                    ...(tenantId ? { 'X-Reporting-Tenant-Id': tenantId } : {}),
                    ...(culture ? { 'Accept-Language': culture } : {}),
                },
            }
            : {}),
    };
}
